import React from "react";
import ManagerNavbar from "../Layout/ManagerNavbar";
import ITRequestPage from "../itsupport/ITRequestPage";

export default function ManagerITSupportPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <ManagerNavbar />
      <ITRequestPage />
    </div>
  );
}
